module.exports = function(media) {
	'use strict'
	media.directive('lazyLoading',lazyLoading);
	lazyLoading.$inject=[];
	function lazyLoading() {
		return {
			restrict: 'A',
			link: function(scope, element, attrs, ctrl) {
	            scope.$on("change-image",function(event, data) {
	            	scope.changeImage();
	            });
	            scope.changeImage = function() {
	            	element.attr('src','');
	            	element.addClass('spinner-show');
	            	element.removeClass('spinner-hide');
	            }
				element.on('load', function() {
		            // Set visibility: true + remove spinner overlay
		            element.addClass('spinner-hide');
		            element.removeClass('spinner-show');
          		});
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/mediaModule/lazyLoadingDirective.js
// module id = 513
// module chunks = 0